exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mde-textarea-wrapper {\n  position: relative; }\n  .mde-textarea-wrapper textarea.mde-text {\n    width: 100%;\n    border: 0;\n    padding: 10px;\n    vertical-align: top;\n    resize: none;\n    overflow-y: auto; }\n", ""]);
